<template lang="html">
    <v-row no-gutters>
      <label style="font-weight: bold;" class="mt-3 mr-1"> {{ $t('title.coligadas') }} </label>
      <v-chip  class="mr-2 my-2 rounded" :color="infoTenants[tenant].color" style="color: white;" v-for="tenant in tenants" :key="tenant">
        {{ infoTenants[tenant].name }}
      </v-chip>
    </v-row>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TenantUsuarioLogadoList',
  props: {
    tenants: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
  },
  data() {
    return {
      tenantsUsuario: [],
      usuarioResource: this.$api.usuario(this.$resource),
      infoTenants: {
        epoca: {
          name: this.$t('sistema.epoca'),
          color: '#f05a8c',
        },
        kabum: {
          name: this.$t('sistema.kabum'),
          color: '#ff6500',
        },
        magalu: {
          name: this.$t('sistema.magalu'),
          color: '#0086ff',
        },
      },
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
